export default {
  computed: {
    currency: function() {
      try {
        return this.$store.state.square.currency
      }
      catch (err) {
        return 'AUD'
      }
    },
    paymentRequest: function() {
      return this.$store.state.square.processingRequest
    },
    paymentResponse: function() {
      return this.$store.state.square.processingResult
    },
    debugData: function() {
      try {
        return {
          request: this.paymentRequest,
          response: this.paymentResponse
        }
      }
      catch (err) {
        return {
          request: {},
          response: {}
        }
      }
    },
    receiptNo: function() {
      try {
        return this.paymentResponse.payment.receipt_no
      }
      catch (_err) {
        return '--'
      }
    },
    paymentID: function() {
      try {
        return this.paymentResponse.payment.reference
      }
      catch (_err) {
        return '--'
      }
    },
    paymentAmount: function() {
      try {
        return this.$store.state.square.paymentDetails.total_amount + this.$store.state.square.paymentDetails.surcharge
      }
      catch (_err) {
        return '--'
      }
    },
    amount: function() {
      try {
        return this.paymentResponse.payment.approved_amount
      }
      catch (_err) {
        return '--'
      }
    },
    txnid: function() {
      try {
        return this.$store.state.square.paymentTxn.txnid
      }
      catch (_err) {
        return '--'
      }
    },
    txndate: function() {
      try {
        return this.$store.state.square.paymentTxn.date
      }
      catch (_err) {
        return '0'
      }
    },
    txnAmount: function() {
      try {
        if (typeof this.$store.state.square.paymentTxn.gross === 'number') {
          return this.$store.state.square.paymentTxn.gross
        }
        else if (typeof this.$store.state.square.paymentTxn.total === 'number') {
          return this.$store.state.square.paymentTxn.total
        }
        return '--'
      }
      catch (_err) {
        return '--'
      }
    },
    cardType: function() {
      try {
        return this.paymentResponse.payment.payment_subtype
      }
      catch (err) {
        return 'unknown'
      }
    }
  }
}
